export default __webpack_public_path__ + "static/media/sofa-2.87b31bae.png";